export const ALL_CURRENCIES_VALUE = 'all';
